<template>
  <div
    class="modal-mask artwork-modal bidding-increment-modal"
    @click="checkClickTarget"
    data-close-modal
  >
    <div v-if="!oneResult" class="search-modal-controls">
      <a class="control-button preview" @click="previewModal">
        <span class="icon icon-arrow-left"></span>
      </a>
      <a class="control-button next" @click="nextModal">
        <span class="icon icon-arrow-right"></span>
      </a>
    </div>
    <div class="modal-dialog modal-lg">
      <div class="modal-content search-modal"
           :style="modalBox">
        <slot name="header">
          <button
            class="bidding-increment-modal__close btn-oval btn-oval--transparent modal__close"
            data-close-modal
          >
            <span
              class="icon icon-close-big"
              data-close-modal
            />
          </button>
        </slot>
        <slot name="body">
          <transition @beforeEnter="beforeContentEnter"
                      @enter="enterContentAnimation"
                      @beforeLeave="beforeContentLeave"
                      @leave="leaveContentAnimation"
                      :css="false">
            <ModalContent :artwork="artworks[currentArtworkIndex]"
                       :key="`modal_${currentArtworkIndex}`"
                       ref="modalContent"/>
          </transition>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-param-reassign: ["error", { "props": false }] */
  /* eslint no-unused-expressions: ["error", { "allowTernary": true }] */
  import IsIos from '@/shared/mixins/is_ios';
  import { mapGetters } from 'vuex';
  import GlobalEvents from 'vue-global-events';
  import { UPDATE_CURRENT_ARTWORK_INDEX } from '../../../store/mutation-types';
  import ModalContent from './modal_content';

  export default {
    name: 'SearchResultsModal',
    components: {
      GlobalEvents,
      ModalContent,
    },
    data() {
      return {
        slideToLeft: false,
        duringAnimation: false,
        modalBox: {
          height: 'auto',
        },
      };
    },
    mixins: [IsIos],
    computed: {
      ...mapGetters(['artworks', 'currentArtworkIndex']),
      lastIndex() {
        return this.artworks.length - 1;
      },
      oneResult() {
        return this.artworks.length === 1;
      },
    },
    methods: {
      setModalHeight() {
        const modalHeight = this.$refs.modalContent.$el.clientHeight;
        this.modalBox.height = `${modalHeight}px`;
      },
      checkClickTarget(event) {
        const clickedElementAttributes = event.target.attributes;

        Object.values(clickedElementAttributes).find((attribut) => {
          if (attribut.nodeName === 'data-close-modal') {
            this.closeModal();
          }
          return true;
        });
      },
      closeModal() {
        const currentArtworkId = this.artworks[this.currentArtworkIndex].id;

        if (this.isIos) {
          this.$scrollTo(`#artwork_${currentArtworkId}`, -1);
          document.body.classList.remove('ios-fix');
        } else {
          document.body.classList.remove('modal-open');
        }
        this.$store.commit(UPDATE_CURRENT_ARTWORK_INDEX, '');
      },
      nextModal() {
        this.setModalHeight();
        if (this.duringAnimation) return;
        this.duringAnimation = true;
        this.slideToLeft = false;
        if (this.isLastModal()) {
          this.switchToFirstModal();
        } else {
          this.$store.commit(UPDATE_CURRENT_ARTWORK_INDEX, this.currentArtworkIndex + 1);
        }
      },
      previewModal() {
        this.setModalHeight();
        if (this.duringAnimation) return;
        this.duringAnimation = true;
        this.slideToLeft = true;
        if (this.isFirstModal()) {
          this.switchToLastModal();
        } else {
          this.$store.commit(UPDATE_CURRENT_ARTWORK_INDEX, this.currentArtworkIndex - 1);
        }
      },
      switchToFirstModal() {
        this.$store.commit(UPDATE_CURRENT_ARTWORK_INDEX, 0);
      },
      switchToLastModal() {
        this.$store.commit(UPDATE_CURRENT_ARTWORK_INDEX, this.lastIndex);
      },
      isFirstModal() {
        return this.currentArtworkIndex === 0;
      },
      isLastModal() {
        return this.currentArtworkIndex === this.lastIndex;
      },
      beforeContentEnter(el) {
        el.style.transform = 'translateX(100%)';
      },
      enterContentAnimation(el, done) {
        let translateValue = 100;
        let round = 0;

        this.slideToLeft ? translateValue = -100 : translateValue = 100;
        const interval = setInterval(() => {
          round += 1;
          el.style.transform = `translateX(${translateValue}%)`;
          this.slideToLeft ? translateValue += 2 : translateValue -= 2;
          if (round > 50) {
            clearInterval(interval);
            this.setModalHeight();
            this.duringAnimation = false;
            setTimeout(() => { this.modalBox.height = 'auto'; }, 400);
            done();
          }
        }, 8);
      },
      beforeContentLeave(el) {
        el.style.position = 'absolute';
      },
      leaveContentAnimation(el, done) {
        let translateValue = 0;
        let round = 0;

        const interval = setInterval(() => {
          round += 1;
          el.style.transform = `translateX(${translateValue}%)`;
          this.slideToLeft ? translateValue += 2 : translateValue -= 2;
          if (round > 50) {
            clearInterval(interval);
            done();
          }
        }, 8);
      },
    },
    mounted() {
      window.addEventListener('resize', this.setModalHeight);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.setModalHeight);
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/index.vue?1396a10c